<template>
     <vs-popup title="Add item" class="popup-add-item-to-order" :active.sync="config.isActive">
        <!-- <div v-if="config && config.item_info"> -->
            <div class="p-2 flex align-center border-bottom-custom" style="height: 80px;" v-if="config && config.item_info">
                <div v-if="config.item_info.image" class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                        :style="`background-image: url('${config.item_info.image}')`"></div>
                <div v-else class="rounded-item" style="height: 51px; width: 51px; background-size: cover; background-position: center; border: 1px solid #bfbfbf"
                    :style="`background-image: url('${default_image}')`"></div>
                <div class="ml-3 item-title">
                    <p class="font-extrabold text-lg item-name">{{config.item_info.name}}</p>
                    <div class="text-grey-custom text-sm" v-if="config.item_info.item_variants && config.item_info.item_variants[0]">
                        <p>Price: ${{parseFloat(total).toFixed(2)}}</p>
                        <!-- <p>Price: ${{parseFloat(config.item_info.item_variants[0].price).toFixed(2)}}</p> -->
                    </div>
                </div>
            </div>

            <div class="info-list" style="height: calc(100% - 140px); overflow: hidden" v-if="config && config.item_info">
                <div class="overflow-auto h-full pb-6 pt-4">
                    <div class="p-2" v-if="config.item_info.item_variants">
                        <p class="font-bold text-lg">Select an option:</p>
                        <div v-for="(vari, index) in config.item_info.item_variants" :key="index" class="pt-2">
                            <ul>
                                <li>
                                    <!-- <vs-radio v-model="variant" vs-name="variant" class="w-full" :vs-value="vari" @click.native="getTotal(modifier)">
                                        <div>{{vari.name}}</div>
                                        <div>${{parseFloat(vari.price).toFixed(2)}}</div>
                                    </vs-radio> -->
                                    <label class="vs-component con-vs-radio vs-radio-primary w-full">
                                        <input name="variant" v-model="variant" type="radio" class="vs-radio--input" :id="vari.id" :value="vari" @click="getVariant(vari)">
                                        <span class="vs-radio position-relative" :class="{'bg-primary': variant.id == vari.id}">
                                            <span :class="{'vs-radio--borde': !(variant.id == vari.id)}"></span>
                                            <span class="vs-radio--circle" style="position: relative;"></span>
                                            <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i>
                                        </span>
                                        <span class="vs-radio--label">
                                            <div class="content">{{vari.name}}</div>
                                            <div>${{parseFloat(vari.price).toFixed(2)}}</div>
                                        </span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="config.item_info.modifier && config.item_info.modifier.length > 0">
                        <div v-for="(mod, i) in modifier" :key="i">
                            <div class="p-2" v-if="mod.is_selected && mod.details.length > 0">
                                <p class="font-bold text-lg">{{mod.modifier_name}}</p>
                                <div v-if="mod.type == 'multi'">
                                    <div v-for="(detail, index) in mod.details" :key="index" class="pt-2">
                                        <ul>
                                            <li>
                                                <vs-checkbox :value="detail.selected" @click="changeStatusModifier(index, i)">
                                                    <div>{{detail.name}}</div>
                                                    <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                                                </vs-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-else :key="radio_key">
                                    <div v-for="(detail, index) in mod.details" :key="index" class="pt-2">
                                        <ul>
                                            <li>
                                                <!-- <vs-radio class="w-full" v-model="mod.value" :vs-value="detail" :vs-name="'modifier' + mod.modifier_name" @click.native="changeStatusModifier(index, i)">
                                                    <div>{{detail.name}}</div>
                                                    <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                                                </vs-radio> -->
                                                <label class="vs-component con-vs-radio vs-radio-primary w-full">
                                                    <input :name="i + 'modifier' + mod.modifier_name" v-model="mod.value" type="radio" class="vs-radio--input" :id="detail.id" :value="detail" @click="changeStatusModifier(index, i)">
                                                    <span class="vs-radio position-relative" :class="{'bg-primary': mod.value && mod.value.id == detail.id}">
                                                        <span :class="{'vs-radio--borde': !(mod.value && mod.value.id == detail.id)}"></span>
                                                        <span class="vs-radio--circle" style="position: relative;"></span>
                                                        <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i>
                                                    </span>
                                                    <span class="vs-radio--label">
                                                        <div class="content">{{detail.name}}</div>
                                                        <div>${{parseFloat(detail.price).toFixed(2)}}</div>
                                                    </span>
                                                </label>
                                                <input :name="i + 'modifier' + mod.modifier_name" v-model="mod.value" type="radio" class="vs-radio--input" :id="'modifier' + mod.modifier_name">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
        <div class="p-2 w-full flex justify-between align-center border-top-custom">
            <vs-input-number size="medium" v-model="quantity" :min="1" :max="50"/>
            <vs-button @click="addItemToOrder">Submit</vs-button>
        </div>
     </vs-popup>
</template>

<script>
    export default {
        name: 'popup-add-item-to-order',
        props: {
            config: {
                type: Object,
                required: true
            }
        },
        data() {
            let variant = null;
            let modifier = [];
            let total = 0;
            if(this.config && this.config.item_info) {
                if(this.config.item_info.item_variants) {
                    variant = this.config.item_info.item_variants[0];
                    total = this.config.item_info.item_variants[0].price;
                }
                if(this.config.item_info.modifier) {
                    let temp = JSON.parse(JSON.stringify(this.config.item_info)).modifier;
                    modifier = [];
                    for(let i = 0; i < temp.length; i++) {
                        if(temp[i].is_selected) {
                            modifier.push(temp[i]);
                        }
                    }
                    modifier = this.initModifierStatus(modifier);
                    // console.log(modifier);
                }
            }
            if(modifier.length) {
                this.getTotal(modifier);
            }
            return {
                default_image: 'https://www.mbrsg.ae/MBRSG/media/Images/no-image-icon-6.png',
                quantity: 1,
                variant,
                modifier,
                radio_key: 0,
                total
            }
        },
        watch: {
            config: {
                immediate: true,
                deep: true,
                handler() {
                    if(this.config.isActive) {
                        if(this.config.item_info.item_variants) {
                            this.variant = this.config.item_info.item_variants[0];
                        }
                        this.radio_key++;
                    } else {
                        this.removeRadio();
                        this.modifier = [];
                        this.radio_key++;
                    }
                }
            }
        },
        methods: {
            removeRadio() {
                for(let i = 0; i < this.modifier.length; i++) {
                    if(this.modifier[i].type == 'single') {
                        if(document.getElementById('modifier'+ this.modifier[i].modifier_name)) {
                            document.getElementById('modifier'+ this.modifier[i].modifier_name).click();
                        }
                    }
                }
            },
            getVariant(vari) {
                this.variant = vari;
                this.total = this.getTotal(this.modifier, this.variant);
            },
            changeStatusModifier(detail_index, mod_index) {
                if(this.modifier[mod_index] && this.modifier[mod_index].details[detail_index]) {
                    if(this.modifier[mod_index].type == 'multi') {
                        this.modifier[mod_index].details[detail_index].selected = !this.modifier[mod_index].details[detail_index].selected;
                    } else {
                        // for(let i = 0; i < this.modifier[mod_index].details.length; i++) {
                            //     this.modifier[mod_index].details[i].selected = false;
                        // }
                        // this.modifier[mod_index].details[detail_index].selected = true;
                        this.modifier[mod_index].value = this.modifier[mod_index].details[detail_index];
                    }
                    this.total = this.getTotal(this.modifier, this.variant);
                }
            },
            initModifierStatus(list) {
                let mod_list = list;
                if(mod_list) {
                    for(let i = 0; i < mod_list.length; i++) {
                        if(mod_list[i].type == 'multi') {
                            for(let j = 0; j < mod_list[i].details.length; j++) {
                                mod_list[i].details[j].selected = false;
                            }
                        } else {
                            mod_list[i].value = null;
                        }
                    }
                }
                return mod_list;
            },
            getTotal(modifier, variant) {
                let total = 0;
                if(modifier) {
                    for(let i = 0; i < modifier.length; i++) {
                        let details = modifier[i].details;
                        if(modifier[i].type == 'multi') {
                            for(let j = 0; j < details.length; j++) {
                                if(details[j].selected) {
                                    total = total + parseFloat(details[j].price);
                                }
                            }
                        } else {
                            if(modifier[i].value && modifier[i].value.price) {
                                total = total + parseFloat(modifier[i].value.price);
                            }
                        }
                    }
                }
                if(variant && variant.price) {
                    total = total + variant.price;
                }
                // console.log(total);
                return total;
            },
            getModifierToSubmit(modifier) {
                let mod_arr = modifier;
                let temp = [];
                for(let i = 0; i < mod_arr.length; i++) {
                    if(mod_arr[i].type == 'multi') {
                        // for(let j = 0; j < mod_arr[i].details.length; j++) {
                        //     if(mod_arr[i].details[j].selected == true) {
                        //         // mod_arr[i].details.splice(j, 1);
                        //         temp.push(mod_arr[i]);
                        //     }
                        //     // if(mod_arr[i].details[j] && mod_arr[i].details[j].selected) {
                        //     //     delete mod_arr[i].details[j].selected;
                        //     // }
                        // }
                        let detail_temp = [];
                        for(let j = 0; j < mod_arr[i].details.length; j++) {
                            if(mod_arr[i].details[j].selected == true) {
                                detail_temp.push(mod_arr[i].details[j]);
                            }
                            if(mod_arr[i].details[j] && mod_arr[i].details[j].selected) {
                                delete mod_arr[i].details[j].selected;
                            }
                        }
                        mod_arr[i].details = detail_temp;
                        temp.push(JSON.parse(JSON.stringify(mod_arr[i])));
                    } else {
                        if(mod_arr[i].value) {
                            mod_arr[i].details = [];
                            mod_arr[i].details.push(mod_arr[i].value);
                            // delete mod_arr[i].value;
                        } else {
                            mod_arr[i].details = [];
                        }
                        temp.push(mod_arr[i])
                    }
                }
                temp = this.parseFloatPrice(temp);
                return temp;
            },
            parseFloatPrice(mod_list) {
                let temp = JSON.parse(JSON.stringify(mod_list));
                if(temp) {
                    for(let i = 0; i < temp.length; i++) {
                        if(temp[i].details) {
                            for(let j = 0; j < temp[i].details.length; j++) {
                                temp[i].details[j].price = parseFloat(temp[i].details[j].price);
                            }
                        }
                    }
                }
                return temp;
            },
            addItemToOrder(){
                // console.log(this.variant);
                if(this.config && this.config.item_info) {
                    let obj = {
                        item_id: this.config.item_info.id,
                        quantity: this.quantity,
                        item_name: this.config.item_info.name,
                        item_variant: this.variant,
                        item_modifier: this.getModifierToSubmit(this.modifier)
                    }
                    // console.log(obj)
                    this.$emit('AddItemToOrder', obj);
                    this.config.isActive = false;
                }
            },
        }
    }
</script>